import React, {useState} from "react";
import RangeSlider from "../RangeSlider/RangeSlider";

const MainContent = () => {
  return (
    <div className="mx-auto px-10 xl:px-0 max-w-[1165px] mt-[50px] md:mt-[154px]">
      <div className="flex flex-col xl:flex-row gap-[55px]">
        <div className="md:min-w-[470px]">
          <div className="flex flex-col md:flex-row  gap-[10px]">
            <div className="grow border border-main-green bg-main-black rounded-[10px] text-center">
              <h2 className="mt-[18px] text-main-green mb-[8px] font-semibold text-res-xs">
                Current Price
              </h2>
              <h1 className="text-[30px] leading-[36px] font-bold pb-[23px]">
                $1,500.00
              </h1>
            </div>
            <div className="grow border border-main-green bg-main-black rounded-[10px] text-center">
              <h2 className="mt-[18px] text-main-green mb-[8px] font-semibold text-res-xs">
                Current Discount
              </h2>
              <h1 className="text-[30px] leading-[36px] font-bold pb-[23px]">
                20%
              </h1>
            </div>
          </div>
          <div className="bg-custom-gradient py-[50px] flex flex-col items-center mt-[10px] rounded-[10px]">
            <h2 className="text-[30px] leading-[36px] font-semibold text-main-black pb-[8px]">
              Buy Access
            </h2>
            <p className="text-[15px] leading-[18px] text-main-black font-semibold mb-[9px]">
              Select Subscription days
            </p>
            <div>
              <RangeSlider></RangeSlider>
            </div>
            <div>
              <button className="bg-main-black rounded-[20px] w-[173px] h-[40px] font-bold text-res-xs">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div className="grow">
          <p className="text-res-xs font-bold">
            Lorem ipsum dolor sit amet consectetur. Gravida non dolor vitae
            facilisi nisl mattis imperdiet mi. Purus iaculis non arcu nunc nulla
            leo etiam cras. Facilisis enim pretium enim tristique amet in nullam
            adipiscing ultricies. Elit consectetur sed faucibus et ac at
            elementum laoreet donec. Volutpat laoreet lorem sagittis gravida
            posuere sagittis orci elementum. Scelerisque lacus lectus bibendum
            elementum nam nunc enim duis amet. Morbi vel enim turpis blandit
            iaculis eget quis. Faucibus id rutrum tincidunt tempus gravida
            tincidunt. Nibh est odio ac viverra non quis pulvinar enim lectus.
            Amet quis arcu justo mattis erat. At dictum sem ultricies est
            posuere blandit. Egestas dictum leo varius euismod sapien mattis
            mattis amet dis.
            <br />
            <br />
            Ullamcorper risus aliquet adipiscing viverra nisl molestie
            pellentesque at. Enim vitae commodo urna sed eu odio sit. Mi rhoncus
            ut placerat non. Tincidunt risus eros maecenas vel dictum
            consectetur bibendum. Dolor eu sapien at diam porta aliquet. Eu enim
            eget turpis mi faucibus aliquam nunc sit eget. Id pellentesque sed
            magna faucibus cursus.
            <br />
            <br />
            Pellentesque nibh vel orci id suspendisse blandit fames non.
            Pharetra convallis non amet pharetra donec enim sollicitudin proin
            consectetur. Blandit donec pharetra integer tempus tellus diam
            massa. Pretium id nunc ultrices vitae pulvinar vitae neque iaculis.
            Sagittis in adipiscing molestie diam magna elementum a. Molestie
            odio ultrices est risus aliquam tristique. Porttitor felis volutpat
            dignissim bibendum. Eu faucibus turpis tincidunt aliquam duis id sed
            sagittis. Nunc pellentesque id aliquam enim. Volutpat cursus in
            donec vel sed nulla nunc aliquam eget. Leo porttitor amet elit
            turpis. Vestibulum in maecenas tortor arcu.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
